import ArrivingSoon from "./ArrivingSoon";

export default ArrivingSoon;
